import React, { useState, useEffect } from "react";
import { Modal, Button } from "antd";
import { LeftOutlined, RightOutlined, CloseOutlined } from "@ant-design/icons";

const ScreenshotCarousel = ({ images, visible, onClose, interval = 2000,initialIndex = 0 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Auto-slide functionality
    useEffect(() => {
        if (!visible) return;

        const timer = setInterval(() => {
            if (currentIndex === images.length - 1) {
                onClose();
                return;
            }
            goNext();
        }, interval);

        return () => clearInterval(timer);
    }, [currentIndex, visible]);

    // 👇 Update index when modal opens with a new initialIndex
    useEffect(() => {
        if (visible) {
            setCurrentIndex(initialIndex);
        }
    }, [visible, initialIndex]);

    // Keyboard navigation


    
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "ArrowRight") goNext();
            if (event.key === "ArrowLeft") goBack();
            if (event.key === "Escape") onClose();
        };

        if (visible) window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [currentIndex, visible]);

    // Navigate backward
    const goBack = () => {
        setCurrentIndex((prevIndex) => {
            // If we're at the first image, stay there
            if (prevIndex === 0) {
                return prevIndex;
            }
            return prevIndex - 1;
        });
    };

    // Navigate forward
    const goNext = () => {
        setCurrentIndex((prevIndex) => {
            // If we're at the last image, close the modal
            if (prevIndex === images.length - 1) {
                setTimeout(() => onClose(), 100); // Small delay to ensure smooth transition
                return prevIndex;
            }
            return prevIndex + 1;
        });
    };

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            closable={false}
            centered
            width="65vw"
            bodyStyle={{
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "60vh",
            }}
        >
            <div style={{ position: "relative", width: "100%", textAlign: "center" }}>
                {/* Back Button */}
                <Button
                    icon={<LeftOutlined />}
                    onClick={goBack}
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "20px",
                        transform: "translateY(-50%)",
                        zIndex: 10,
                        background: "rgba(255,255,255,0.7)",
                        color: "#333",
                        border: "none",
                        fontSize: "18px",
                        padding: "12px",
                        transition: "all 0.3s ease-in-out",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.1)")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.7)")}
                />

               {/* Image Wrapper with Timestamp Overlay */}
<div style={{ position: "relative", display: "inline-block" }}>
    {/* Image */}
    <img
        src={images[currentIndex]?.url}
        alt={`Screenshot ${currentIndex + 1}`}
        style={{
            maxWidth: "85%",
            maxHeight: "75vh",
            borderRadius: "8px",
            boxShadow: "0px 10px 30px rgba(0,0,0,0.2)",
            transition: "opacity 0.5s ease-in-out",
        }}
    />

    {/* Timestamp Overlay - Positioned in Top-Left */}
    <div style={{
        position: "absolute",
        top: "-22px",   // Moves timestamp to the top
        left: "10px",  // Moves timestamp to the left
        background: "rgba(0, 0, 0, 0.6)", // Dark background for contrast
        color: "#fff",
        padding: "6px 12px",
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: "600",
        backdropFilter: "blur(10px)",
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.3)",
        textAlign: "center"
    }}>
        📅 {images[currentIndex]?.timestamp || "No Timestamp"}
    </div>
</div>


                {/* Next Button */}
                <Button
                    icon={<RightOutlined />}
                    onClick={goNext}
                    style={{
                        position: "absolute",
                        top: "50%",
                        right: "20px",
                        transform: "translateY(-50%)",
                        zIndex: 10,
                        background: "rgba(255,255,255,0.7)",
                        color: "#333",
                        border: "none",
                        fontSize: "18px",
                        padding: "12px",
                        transition: "all 0.3s ease-in-out",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.1)")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.7)")}
                />

                {/* Image Index Display */}
                <div style={{
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    background: "rgba(255,255,255,0.8)",
                    color: "#333",
                    padding: "3px 20px",
                    borderRadius: "999px", // pill shape                    fontSize: "19px",
                    fontWeight: 800,
                    letterSpacing: "1px",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    border: "1.4px solid black",  
                    bottom: "-25px",
                    WebkitBackdropFilter: "blur(8px)",
                    backdropFilter: "blur(8px)",
                    textShadow: "0 1px 1px rgba(255,255,255,0.5)",



                }}>
                    {currentIndex + 1} / {images.length}
                </div>

                {/* Close Button */}
                <Button
                    icon={<CloseOutlined style={{ fontSize: "20px" }} />}
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: "-25px",
                        right: "0px",
                        zIndex: 100,
                        background: "rgba(255,255,255,0.8)",
                        color: "#333",
                        border: "2px solid #ccc",
                        padding: "12px",
                        borderRadius: "50%",
                        transition: "all 0.3s ease-in-out",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#ff4d4f"; // red
                        e.currentTarget.style.color = "white";
                        e.currentTarget.style.transform = "scale(1.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "white";
                        e.currentTarget.style.color = "#333";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                />
            </div>
        </Modal>
    );
};

export default ScreenshotCarousel;
